export default __webpack_public_path__ + "static/media/logo.4f9a5941.svg";